module.exports = __webpack_public_path__ + "static/7-d177a3f53da2e2a7ffde25873e3024b8.jpeg";